import {SHOW_ALERT_APP,SHOW_DIALOG_APP,DIALOG_ANSWER,SHOW_MESS_APP} from '../types'

const handlers = {
  [SHOW_MESS_APP]: (state, {payload}) => ({...state, curmessage: payload}),
  [SHOW_ALERT_APP]: (state, {payload}) => ({...state, alertmessage: payload}),
  [SHOW_DIALOG_APP]: (state, {payload}) => ({...state, dialog: payload}),
  [DIALOG_ANSWER]: (state, {payload}) => ({...state, dialoganswer: payload}),
  DEFAULT: state => state
  }
  
export const infowinReducer = (state, action) => {
    const handler = handlers[action.type] || handlers.DEFAULT
    return handler(state, action)
  }
  
